module.exports = __webpack_public_path__ + "static/media/icon_error.e280c783.svg";